import * as Icons from '@ant-design/icons';
import { Button, Drawer, Flex, Modal, Table, Typography } from 'antd';
import { useCallback, useState } from 'react';
import { useCertificateStore } from '../../certificate.store';
import { formatDate } from 'services/date';
import { TagField, TextField } from '@refinedev/antd';
import _ from 'lodash';
import { ModalObservation } from './ModalObservation';

interface IDrawerEmissioesHistoryProps {
  openDrawer: boolean;
  setOpenDrawer: (openDrawer: boolean) => void;
}

export const DrawerEmissioesHistory = ({
  openDrawer,
  setOpenDrawer
}: IDrawerEmissioesHistoryProps) => {
  const { certificate, openObservationModal } = useCertificateStore();

  return (
    <>
      <Drawer
        closable={false}
        closeIcon={false}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        width="70%"
        title={
          <Flex vertical>
            <Typography.Title level={4} className="!mb-0">
              Histórico de emissões
            </Typography.Title>
            <Typography.Text type="secondary" className="font-normal">
              Acompanhe o histórico de todas as vias emitidas
            </Typography.Text>
          </Flex>
        }
        extra={
          <Button
            variant="text"
            color="default"
            icon={<Icons.CloseOutlined />}
            onClick={() => setOpenDrawer(false)}
          ></Button>
        }
      >
        <Table dataSource={certificate?.versions}>
          <Table.Column
            title="Autor"
            dataIndex={['author', 'name']}
            key="author"
          />
          <Table.Column
            title="Número do registro"
            dataIndex="registration_number"
            key="registration_number"
            render={(_, record) => (
              <TextField
                value={
                  record.previous_registration_number ??
                  record.new_registration_number
                }
              />
            )}
          />
          <Table.Column
            title="Ação"
            dataIndex="action"
            key="action"
            render={(_, render) => (
              <TagField
                color={render.previous_registration_number ? 'red' : 'green'}
                value={
                  render.previous_registration_number ? 'Invalidado' : 'Emitido'
                }
              />
            )}
          />
          <Table.Column
            title="Data da ação"
            dataIndex="created_at"
            key="created_at"
            render={value => formatDate(value, 'DD/MM/YYYY - HH:mm')}
          />
          <Table.Column
            title="Motivo"
            dataIndex="observations"
            key="observations"
            render={(_, record) => {
              if (!record.previous_registration_number) return '-';

              return (
                <Button
                  variant="outlined"
                  color="default"
                  size="small"
                  onClick={() =>
                    openObservationModal(
                      'Observações - Nova emissão',
                      record.created_at,
                      record.author.name,
                      record.observations
                    )
                  }
                >
                  Ver observação
                </Button>
              );
            }}
          />
        </Table>
      </Drawer>
    </>
  );
};
